
import React from 'react';
import { NavLink } from "./NavLink";
import { LucideIcon, MoreHorizontal } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface DesktopNavProps {
  navItems: Array<{
    label: string;
    href: string;
    icon: LucideIcon;
    badge?: number | null;
  }>;
}

const DesktopNav = ({ navItems }: DesktopNavProps) => {
  const { t } = useLanguage();
  const visibleItems = navItems.slice(0, 4);
  const moreItems = navItems.slice(4);
  
  return (
    <>
      <div className="flex-shrink-0 flex items-center">
        <NavLink to="/" className="font-display text-xl font-bold tracking-tight text-primary">
          KLIKAN
        </NavLink>
      </div>
      <div className="ml-10 flex items-center space-x-5">
        {visibleItems.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            icon={item.icon}
            badge={item.badge}
            className="flex items-center"
          >
            {item.label}
          </NavLink>
        ))}
        {moreItems.length > 0 && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm" className="flex items-center gap-1">
                <MoreHorizontal className="h-4 w-4" />
                <span>{t('more')}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="z-[100]">
              {moreItems.map((item) => (
                <DropdownMenuItem key={item.href} asChild>
                  <Link to={item.href} className="flex items-center gap-2 w-full cursor-pointer">
                    <item.icon className="h-4 w-4" />
                    <span>{item.label}</span>
                  </Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
    </>
  );
};

export default DesktopNav;
